// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ep-z","badgeLink":"fp-z","category":"gp-z"};